export const retryOnce = <T>(attempt: () => Promise<T>): Promise<T> => attempt().catch(attempt)
